<div v-if="minCount" class="product-progress-container container">
    <div v-if="countToFreeDelivery > 0" class="small mb-1">
        До бесплатной пересылки: {{ countToFreeDelivery }} шт.
    </div>
    <div v-else-if="isFree" class="small mb-1">
        <b>Бесплатная</b> пересылка на ваш заказ
    </div>
    <div class="product-progress-bar-b" :class="{'product-progress-is-full': isFree}">
        <div class="product-progress-bar">
            <div class="product-progress-line" :style="{width: percToFreeDelivery + '%'}"></div>
        </div>
    </div>
</div>
